<template>
  <div>
    <form @submit.prevent="filterData">
      <div class="w-auto my-2">
        <div class="py-4 font-medium border-b border-teal-400">Unterkategorien</div>
        <ul class="list-reset pl-3 pt-3">
          <li v-for="subcategory in subcategories" :key="subcategory.id">
            <router-link
              :to="{ name: 'products', query: { category: subcategory.slug } }"
              class="block px-4 text-gray-900 hover:text-teal-400"
            >{{ subcategory.name_de }}</router-link>
          </li>
        </ul>
        <div class="pt-2">
          <div class="py-4 font-medium border-b border-teal-400">Kategorien</div>
          <ul class="list-reset pl-3 pt-3">
            <li v-for="category in categories" :key="category.id">
              <router-link
                :to="{ name: 'products', query: { category: category.slug } }"
                v-if="category.parent_id === null"
                :class="category.name_de == 'Sale' ? 'text-red-600' : ''"
                class="block px-4 text-gray-900 hover:text-teal-400"
              >{{ category.name_de }}</router-link>
            </li>
          </ul>
        </div>
        <div class="pt-2">
          <div class="py-4 font-medium border-b border-teal-400">Preisklasse</div>
          <div class="mt-4 text-right">
            <span class="border p-1 border-teal-400 rounded right text-teal-400">{{ min_price }} €</span>
            <span
              class="ml-1 p-1 border border-teal-400 rounded right text-teal-400"
            >{{ max_price }} €</span>
          </div>
          <el-slider v-model="slider_values" range :min="min_price" :max="max_price"></el-slider>
        </div>
        <div class="pt-2">
          <div class="py-4 font-medium border-b border-teal-400">Filtern nach Marke</div>
          <div v-for="br in brands" :key="br.id">
            <input type="checkbox" class="" :value="br.id" v-model="brand" />
            <label class="px-2 text-sm text-gray-900">{{ br.name }}</label>
          </div>
        </div>
      </div>
      <div class="pt-3 pb-3">
        <button
          class="bg-teal-400 text-white sm:w-full rounded p-2 hover:text-teal-400 hover:bg-white">
            Filter
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      url: "",
      categories: [],
      subcategories: [],
      category: this.$route.query.category,
      min_price: 0,
      max_price: 0,
      slider_values: [],
      brands: [],
      brand: [],
      price: {},
    };
  },
  computed: {
    slug() {
      return this.$route.query.category;
    },
  },
  watch: {
    slug() {
      this.category = this.$route.query.category;

      this.getCategory();
    },
  },

  created() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      axios
        .get(`${process.env.VUE_APP_API}/categories`)
        .then((response) => {
          this.categories = response.data.data;
        })
        .catch((error) => console.log(error));
      if (this.category) {
        axios
          .get(`${process.env.VUE_APP_API}/categories/${this.category}`)
          .then((response) => {
            // console.log(response);
            this.subcategories = response.data.data;
          })
          .catch((error) => console.log(error));
      }
      if (this.$route.query.category) {
        this.getFilters();
      }
    },
    getFilters() {
      axios
        .get(`${process.env.VUE_APP_API}/categories-filters/${this.category}`)
        .then((response) => {
          this.min_price = response.data.min_price;
          this.max_price = response.data.max_price;
          this.brands = response.data.brands;
          // console.log(this.$route.query.min_price);
          if (this.$route.query.min_price && this.$route.query.max_price) {
            this.slider_values = [
              this.$route.query.min_price,
              this.$route.query.max_price,
            ];
          } else {
            this.slider_values = [this.min_price, this.max_price];
          }
          // console.log(this.brands);
        })
        .catch((error) => console.log(error));
    },
    filterData() {
      this.url = `?category=${this.category}`;
      if (!this.min_price == 0 || !this.max_price == 0) {
        this.url += `&min_price=${this.slider_values[0]}&max_price=${this.slider_values[1]}`;
        if (!this.brand == 0) {
          this.url += `&brand=${this.brand}`;
        }
      }
      this.$router.push(this.url);
    },
  },
};
</script>

<style></style>
